var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuDelaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "auDelaIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.708,
    height: 36.614,
    viewBox: "0 0 37.708 36.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26314",
    d: "M8.1,21.71a1.13,1.13,0,0,1-.217-2.238c5.428-1.068,7.5-3.694,8.506-10.806a1.13,1.13,0,1,1,2.237.318c-1.137,8.007-3.931,11.45-10.307,12.7a1.114,1.114,0,0,1-.22.021Z",
    transform: "translate(-6.969 -7.695)",
    fill: "#2ACA9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26315",
    d: "M26.913,21.71a1.121,1.121,0,0,1-.22-.021c-6.375-1.255-9.169-4.7-10.306-12.7a1.13,1.13,0,1,1,2.237-.318C19.635,15.778,21.7,18.4,27.13,19.472a1.13,1.13,0,0,1-.217,2.238ZM17.5,33.466a1.129,1.129,0,0,1-1.117-.971c-1.011-7.111-3.078-9.737-8.507-10.806a1.13,1.13,0,1,1,.437-2.217c6.375,1.256,9.169,4.7,10.306,12.705a1.13,1.13,0,0,1-.96,1.278A1.179,1.179,0,0,1,17.5,33.466Z",
    transform: "translate(-6.969 -7.695)",
    fill: "#2ACA9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26316",
    d: "M20.589,37.317a1.179,1.179,0,0,1-.16-.011,1.13,1.13,0,0,1-.96-1.278c1.137-8.007,3.931-11.45,10.306-12.705a1.13,1.13,0,1,1,.437,2.217c-5.429,1.069-7.5,3.695-8.506,10.806a1.129,1.129,0,0,1-1.117.971Zm9.132,1.69a1.13,1.13,0,0,1-.217-2.238c4.095-.806,5.655-2.8,6.423-8.2a1.13,1.13,0,1,1,2.238.318c-.9,6.362-3.133,9.1-8.224,10.1A1.122,1.122,0,0,1,29.721,39.008Z",
    transform: "translate(-10.051 -11.546)",
    fill: "#2ACA9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26317",
    d: "M47.365,40.414a1.126,1.126,0,0,1-.22-.021c-5.09-1-7.32-3.74-8.224-10.1a1.13,1.13,0,1,1,2.238-.318c.768,5.4,2.329,7.4,6.423,8.2a1.13,1.13,0,0,1-.217,2.238Zm-7.326,9.153a1.13,1.13,0,0,1-1.117-.971c-.768-5.4-2.329-7.4-6.423-8.2a1.13,1.13,0,0,1,.437-2.217c5.091,1,7.32,3.74,8.224,10.1a1.13,1.13,0,0,1-.96,1.278A1.179,1.179,0,0,1,40.038,49.567Z",
    transform: "translate(-13.044 -12.953)",
    fill: "#2ACA9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26318",
    d: "M42.37,44.487a1.179,1.179,0,0,1-.16-.011,1.13,1.13,0,0,1-.96-1.278c.9-6.363,3.133-9.1,8.224-10.1a1.13,1.13,0,0,1,.437,2.217c-4.095.806-5.655,2.8-6.423,8.2A1.13,1.13,0,0,1,42.37,44.487ZM42.151,16.8a1.13,1.13,0,0,1-.217-2.238c2.573-.506,3.507-1.715,4-5.172a1.13,1.13,0,1,1,2.238.318c-.521,3.662-1.706,6.266-5.8,7.072A1.127,1.127,0,0,1,42.151,16.8Z",
    transform: "translate(-15.372 -7.873)",
    fill: "#2ACA9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26319",
    d: "M51.951,16.8a1.127,1.127,0,0,1-.22-.021c-4.093-.805-5.278-3.409-5.8-7.072a1.13,1.13,0,1,1,2.238-.318c.491,3.458,1.426,4.666,4,5.172a1.13,1.13,0,0,1-.217,2.238Zm-4.9,6.123a1.13,1.13,0,0,1-1.117-.971c-.491-3.458-1.426-4.667-4-5.173a1.13,1.13,0,0,1,.437-2.217c4.093.805,5.278,3.41,5.8,7.073a1.131,1.131,0,0,1-.96,1.278,1.192,1.192,0,0,1-.16.011Z",
    transform: "translate(-15.372 -7.873)",
    fill: "#2ACA9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26320",
    d: "M48.658,24.927a1.192,1.192,0,0,1-.16-.011,1.131,1.131,0,0,1-.96-1.278c.522-3.662,1.707-6.267,5.8-7.073a1.13,1.13,0,1,1,.437,2.217c-2.572.506-3.506,1.715-4,5.173A1.13,1.13,0,0,1,48.658,24.927Z",
    transform: "translate(-16.977 -9.879)",
    fill: "#2ACA9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuDelaIcon);
export default __webpack_public_path__ + "static/media/au-dela-icon.d9a249e3c269775b7d6adc12089363c3.svg";
export { ForwardRef as ReactComponent };